import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { StyledText } from "../../../../../assets/typography/typography";
import { colors } from "../../../../../components/colors";
import { CircleContainer } from "../../../../../components/CircleContainer";
import { VerticalDivider } from "../../../../../components/VerticalDivider";

interface OrderTimelineElementProps {
  title: string;
  time: string;
  isLastStep: boolean;
  isFirstStep: boolean;
  children?: React.ReactNode;
  isInProgress?: boolean;
  isRejected?: boolean;
}

export const OrderTimelineElement = ({
  title,
  time,
  isFirstStep,
  isLastStep,
  children,
  isInProgress,
  isRejected,
}: OrderTimelineElementProps) => {
  return (
    <div className="container align-items-center">
      <div className="row" style={{ gap: "16px" }}>
        <div className="d-flex flex-column align-items-center">
          <VerticalDivider
            style={{
              opacity: isFirstStep ? 0 : 1,
            }}
            height="16px"
          />
          <CircleContainer
            height="24px"
            width="24px"
            backgroundColor={
              isLastStep
                ? isRejected
                  ? colors.errorLight
                  : colors.successLight
                : isInProgress
                ? colors.ctaLight
                : colors.ctaInactive
            }
          >
            {isInProgress ? (
              <FontAwesomeIcon
                icon={solid("spinner-third")}
                spin
                color={colors.ctaMain}
              />
            ) : isRejected ? (
              <FontAwesomeIcon icon={solid("x")} color={colors.errorDark} />
            ) : (
              <FontAwesomeIcon
                icon={solid("check")}
                color={isLastStep ? colors.successDark : colors.textPrimary}
              />
            )}
          </CircleContainer>
          <VerticalDivider
            backgroundColor={
              isInProgress ? colors.ctaLight : colors.ctaInactive
            }
            style={{
              opacity: isLastStep ? 0 : 1,
            }}
            height="100%"
          />
        </div>
        <div className="col pt-3 pb-3" style={{ gap: "8px" }}>
          <StyledText
            color={colors.textPrimary}
            className="bodyTextRegular mb-0"
          >
            {title}
          </StyledText>
          <StyledText
            color={colors.textSecondary}
            className="bodySubTextRegular mb-0"
          >
            {time}
          </StyledText>
          {children}
        </div>
      </div>
    </div>
  );
};
